import { useLocation, useNavigate } from 'react-router-dom';

type UseRouteTabsReturn = {
  currentTab: number;
  handleTabChange: (v: number) => void;
};
export const useRouteTabs = (): UseRouteTabsReturn => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const segments = pathname.split('/').filter(Boolean);
  const last = segments[segments.length - 1];
  const isBase = last === 'show';

  const currentTab = isBase ? 0 : Number(last) || 0;

  const handleTabChange = (newValue: number) => {
    const basePath = isBase ? pathname : '/' + segments.slice(0, -1).join('/');

    if (newValue === 0) {
      navigate(basePath);
    } else {
      navigate(`${basePath}/${newValue}`);
    }
  };

  return { currentTab, handleTabChange };
};
